var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var dropdownStyles = {
    containerDiv: function (_a) {
        var _b = _a.props, focused = _b.focused, toggleButton = _b.toggleButton, fluid = _b.fluid, _c = _a.variables, backgroundColor = _c.backgroundColor, containerDivBorderBottom = _c.containerDivBorderBottom, containerDivBorderRadius = _c.containerDivBorderRadius, containerDivBorderColor = _c.containerDivBorderColor, containerDivFocusBorderColor = _c.containerDivFocusBorderColor, containerDivFocusBorderRadius = _c.containerDivFocusBorderRadius, containerDivColor = _c.containerDivColor, toggleButtonSize = _c.toggleButtonSize, width = _c.width;
        return (__assign({ display: 'flex', flexWrap: 'wrap', outline: 0, border: 0, backgroundColor: backgroundColor, borderRadius: containerDivBorderRadius, borderBottom: containerDivBorderBottom, borderColor: containerDivBorderColor, color: containerDivColor, width: fluid ? '100%' : width, position: 'relative' }, (toggleButton && {
            paddingRight: toggleButtonSize,
        }), (focused && {
            borderColor: containerDivFocusBorderColor,
            borderRadius: containerDivFocusBorderRadius,
        })));
    },
    label: function () { return ({
        margin: '.4rem 0 0 .4rem',
    }); },
    list: function (_a) {
        var _b = _a.variables, listMaxHeight = _b.listMaxHeight, width = _b.width, fluid = _a.props.fluid;
        return ({
            position: 'absolute',
            zIndex: 1000,
            maxHeight: listMaxHeight,
            overflowY: 'auto',
            width: fluid ? '100%' : width,
            top: 'calc(100% + 2px)',
        });
    },
    emptyListItem: function (_a) {
        var listItemBackgroundColor = _a.variables.listItemBackgroundColor;
        return ({
            backgroundColor: listItemBackgroundColor,
        });
    },
    toggleButton: function (_a) {
        var _b = _a.variables, toggleButtonSize = _b.toggleButtonSize, width = _b.width, fluid = _a.props.fluid;
        return (__assign({ position: 'absolute', height: toggleButtonSize, width: toggleButtonSize, border: 0, backgroundColor: 'transparent', margin: 0 }, (fluid ? { right: 0 } : { left: "calc(" + width + " - " + toggleButtonSize + ")" })));
    },
};
export default dropdownStyles;
